import Menu from './Menu'

export { Menu }
export default Menu
